import React, { Component } from 'react';
import NavResorts from './NavResorts';
import ResortCard from './ResortCard';
import SortFilter from './SortFilter';
import resorts from '../../general/all-inclusive/includes/resort-slides';
import Slider from 'react-slick';
import SliderArrow from '~/js/components/SliderArrow';
import ResetButton from './ResetButton';

const internals = {
    sliderOptions: {
        lazyLoad: 'ondemand',
        autoplay: false,
        fade: false,
        arrows: true,
        centerMode: true,
        centerPadding: '0',
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 100,
        dots: false,
        nextArrow: <SliderArrow classNames="slick-next" />,
        prevArrow: <SliderArrow classNames="slick-prev" />,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    variableWidth: true,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    variableWidth: true,
                    slidesToShow: 1,
                    centerPadding: '0',
                    lazyLoad: 'progressive',
                },
            },
        ],
    },
};

class AllResorts extends Component {
    constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.filterOpenRef = React.createRef();
        this.filterResults = React.createRef();
    }
    state = {
        activeResorts: [],
        defaultState: true,
        resetState: false,
        disabledFeatures: [],
        disabledActivities: [],
        disabledCountries: [],
        activeComponent: 'None',
        sortState: 'ALPHABETICAL',
        filterItem: {
            [this.props.filterData[0].value]: this.props.filterData[0],
        },
        filterShow: false,
        showButton: false,
        filters: {
            country: [],
            activity: [],
            feature: [],
        },
        filteredResorts: this.props.resorts,
        loading: false,
        featuresByResort: [],
        moodsByResort: [],
        mainFeatures: {}
    };

    componentDidMount() {
        // new fetch features call
        this.getMainFeatures();
        this.createRates();
        this.setState({featuresByResort: this.getFeatures(), moodsByResort: this.getMoods()});
        if (this.props.stickyCheck) {
            window.addEventListener('scroll', () => this.stickyCheck());
        }

        document.addEventListener('mousedown', e => this.handleClickOutside(e));
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.stickyCheck());

        document.removeEventListener('mousedown', e =>
            this.handleClickOutside(e)
        );
    }

    // fetching features update
    getMainFeatures = () => {
        fetch('/fetchResortMainFeatures/')
        .then(res => res.json())
        .then(json =>
            this.setState({
                mainFeatures: json.data.mainFeatures.resorts
            }))
        .catch((error) => {
            console.log(error.message);
            if (error.name === 'AbortError') {
                return;
            }
            throw error;
        });

    };

    setWrapperRef = node => {
        this.wrapperRef = node;
    };

    handleClickOutside = event => {
        const { filterShow } = this.state;
        const filterButton = this.filterOpenRef.current;
        const filterResults = this.filterResults.current;

        if (
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target) &&
            filterShow &&
            event.target !== filterButton &&
            event.target !== filterResults
        ) {
            this.setState({ filterShow: false });
        }
    };

    stickyCheck = () => {
        const { stickyCheck } = this.props;
        const header = document.querySelector('.header');
        const resortModule = document.querySelector('.view-resort-module');
        const resortModuleInner = document.querySelector(
            '.view-resort-module-inner'
        );
        const resortModuleMeasurement = resortModule.getBoundingClientRect();
        const resortModuleInnerHeight = resortModuleInner.offsetHeight;
        const featuresBox = document.querySelector('.features');
        const featuresBoxMeasurement = featuresBox.getBoundingClientRect();
        const featureOffsetTop =
            featuresBoxMeasurement.top + document.documentElement.scrollTop;
        const featureOffsetBottom = featureOffsetTop + featuresBox.offsetHeight;
        const reactInject = document.getElementById('react-inject');
        const spaceLeft =
            featureOffsetBottom - window.scrollY - header.offsetHeight;
        const goingToOverflow = resortModuleInnerHeight > spaceLeft;
        const spaceFromTopSmall =
            resortModuleMeasurement.top - header.offsetHeight <= 0;

        if (
            window.innerWidth >= 992 &&
            resortModule.classList.contains('canSticky') &&
            stickyCheck
        ) {
            if (spaceFromTopSmall && !goingToOverflow) {
                resortModuleInner.classList.add('sticky');
                resortModuleInner.removeAttribute('style');
            } else if (goingToOverflow) {
                resortModuleInner.classList.remove('sticky');
                resortModuleInner.setAttribute(
                    'style',
                    `position: relative;
                    top:
                      ${reactInject.offsetHeight -
                          resortModuleInner.offsetHeight}px;
                      `
                );
            } else {
                resortModuleInner.classList.remove('sticky');
                resortModuleInner.removeAttribute('style');
            }
        } else {
            resortModuleInner.classList.remove('sticky');
            resortModuleInner.removeAttribute('style');
        }
    };

    createRates = () => {
        const { activeResorts } = this.state;
        const { rates } = this.props;

        activeResorts.map(resort => {
            if (rates[resort.rstCode].lowest) {
                resort.rate = rates[resort.rstCode].lowest.avgRate;
            } else {
                resort.rate = 0;
            }
        });
    };

    applyFilter = () => {
        const { filters } = this.state;
        const {
            staticActivities,
            staticResorts,
            features,
            questionsAnswersWithResorts,
            countryCodes,
        } = this.props;

        const activeFeatures = filters.feature;
        const activeCountries = filters.country;
        const activeActivity = filters.activity;
        const activityNames = Object.keys(staticActivities);
        const questionIDs = features.map(feature => feature.questionId);
        const staticRstCodes = staticResorts.map(resort => resort.rstCode);
        let disabledCountries = [];
        let disabledFeatures = [];
        let disabledActivities = [];
        let newActiveResorts = [];
        let resetBoolean = false;
        let activeResortsByCountry = [];
        let activeResortsByFeatures = [];
        let activeResortsByActivity = [];

        const flatten = arr => {
            return arr.reduce((acc, e) => acc.concat(e), []);
        };

        // Get all filter objects

        const featureObjectByResort = questionsAnswersWithResorts.reduce(
            (acc, question) => {
                if (!acc[question.rstCode]) {
                    acc[question.rstCode] = [question.questionId];
                } else {
                    acc[question.rstCode] = [
                        ...acc[question.rstCode],
                        question.questionId,
                    ];
                }

                return acc;
            },
            []
        );

        const countryObjectByResort = staticResorts.reduce((acc, resort) => {
            acc[resort.rstCode] = resort.countryCode;

            return acc;
        }, []);

        const activityObjectByResort = activityNames.reduce((acc, activity) => {
            const iterableEl = staticActivities[activity];

            iterableEl.map(el => {
                if (!acc[el]) {
                    acc[el] = [activity];
                } else {
                    acc[el] = [...acc[el], activity];
                }
            });

            return acc;
        }, []);

        // Apply filters if needed

        if (activeCountries.length > 0) {
            activeResortsByCountry = staticRstCodes.reduce((acc, resort) => {
                if (
                    countryObjectByResort[resort] &&
                    activeCountries.includes(countryObjectByResort[resort])
                ) {
                    acc.push(resort);
                }

                return acc;
            }, []);
            resetBoolean = true;
        }

        if (activeFeatures.length > 0) {
            activeResortsByFeatures = staticRstCodes.reduce((acc, resort) => {
                if (
                    featureObjectByResort[resort] &&
                    activeFeatures.every(el =>
                        featureObjectByResort[resort].includes(el)
                    )
                ) {
                    acc.push(resort);
                }

                return acc;
            }, []);
            resetBoolean = true;
        }

        if (activeActivity.length > 0) {
            activeResortsByActivity = staticRstCodes.reduce((acc, resort) => {
                if (
                    activityObjectByResort[resort] &&
                    activeActivity.every(el =>
                        activityObjectByResort[resort].includes(el)
                    )
                ) {
                    acc.push(resort);
                }

                return acc;
            }, []);
            resetBoolean = true;
        }

        // Condition if all filters are empty

        if (
            !activeFeatures.length > 0 &&
            !activeActivity.length > 0 &&
            !activeCountries.length > 0
        ) {
            this.reset();

            return false;
        }

        // Intersect arrays to find common resorts between all filters

        const intersection = (array1, array2) =>
            array1.filter(value => array2.includes(value));
        const intersectAll = (...array) => array.reduce(intersection);

        let combinedArrays = [
            activeResortsByCountry,
            activeResortsByFeatures,
            activeResortsByActivity,
        ];

        combinedArrays = combinedArrays.reduce((acc, array) => {
            if (array.length > 0) {
                acc.push(array);
            }

            return acc;
        }, []);

        if (combinedArrays.length > 1) {
            newActiveResorts = intersectAll(...combinedArrays);
        } else {
            newActiveResorts = flatten(combinedArrays);
        }

        let resortsNoCountryFilter = [
            activeResortsByFeatures,
            activeResortsByActivity,
        ];

        resortsNoCountryFilter = resortsNoCountryFilter.reduce((acc, array) => {
            if (array.length > 0) {
                acc.push(array);
            }

            return acc;
        }, []);

        if (resortsNoCountryFilter.length > 1) {
            resortsNoCountryFilter = intersectAll(...resortsNoCountryFilter);
        } else {
            resortsNoCountryFilter = flatten(resortsNoCountryFilter);
        }

        // Find disabled filters

        let possibleActivites = newActiveResorts.reduce((acc, resort) => {
            acc.push(activityObjectByResort[resort]);

            return acc;
        }, []);

        possibleActivites = flatten(possibleActivites);

        possibleActivites = Array.from(new Set(possibleActivites));

        disabledActivities = activityNames.filter(
            activity => !possibleActivites.includes(activity)
        );

        let possibleFeatures = newActiveResorts.reduce((acc, resort) => {
            acc.push(featureObjectByResort[resort]);

            return acc;
        }, []);

        possibleFeatures = flatten(possibleFeatures);

        possibleFeatures = Array.from(new Set(possibleFeatures));

        disabledFeatures = questionIDs.filter(
            question => !possibleFeatures.includes(question)
        );

        if (activeFeatures.length > 0 || activeActivity.length > 0) {
            let possibleCountries = resortsNoCountryFilter.reduce(
                (acc, resort) => {
                    acc.push(countryObjectByResort[resort]);

                    return acc;
                },
                []
            );

            possibleCountries = flatten(possibleCountries);

            possibleCountries = Array.from(new Set(possibleCountries));

            disabledCountries = countryCodes.filter(
                country => !possibleCountries.includes(country)
            );

            // Clears country from the activeCountry state if it is currently disabled

            const newActiveCountries = activeCountries.filter(
                country => !disabledCountries.includes(country)
            );

            this.setState(() => {
                const newFilter = { ...filters };

                newFilter.country = newActiveCountries;

                return { filters: newFilter };
            });
        }

        this.setState(
            {
                activeResorts: newActiveResorts,
                defaultState: false,
                disabledCountries: disabledCountries,
                disabledFeatures: disabledFeatures,
                disabledActivities: disabledActivities,
                resetState: resetBoolean,
                showButton: true,
            },
            () => this.filteredResorts()
        );
    };

    selectFilter = (event, item, type) => {
        this.setState(
            prevState => {
                const { filters } = prevState;
                let activeFilter = filters[type];
                const currentFilter = { ...filters };

                if (type === 'country' || type === 'activity') {
                    if (!activeFilter.includes(item)) {
                        activeFilter = [...activeFilter, item];
                    } else {
                        activeFilter = activeFilter.filter(el => el !== item);
                    }
                } else {
                    const questionId = item.questionId;

                    if (!activeFilter.includes(questionId)) {
                        activeFilter = [...activeFilter, questionId];
                    } else {
                        activeFilter = activeFilter.filter(
                            el => el !== questionId
                        );
                    }
                }

                currentFilter[type] = activeFilter;

                return { filters: currentFilter, loading: true };
            },
            () => this.applyFilter()
        );
    };

    reset = () => {
        this.setState({
            defaultState: true,
            activeResorts: this.props.staticResorts,
            resetState: false,
            activeComponent: 'None',
            disabledFeatures: [],
            disabledCountries: [],
            disabledActivities: [],
            showButton: false,
            filters: {
                country: [],
                activity: [],
                feature: [],
            },
            filteredResorts: resorts.resort,
            loading: false,
        });
    };

    createSortObject = item => {
        this.setState({
            filterItem: {
                [item.value]: item,
            },
            sortState: item.value,
        });
    };

    filteredResorts = () => {
        const { staticResorts } = this.props;
        const { sortState, activeResorts, defaultState } = this.state;
        let finalOutput;

        const activeResortsArray = staticResorts.reduce((acc, resort) => {
            if (activeResorts.includes(resort.rstCode)) {
                acc.push(resort);
            }

            return acc;
        }, []);

        const alphabetical = (a, b) => {
            const countryA = a.countryCode.toUpperCase();
            const countryB = b.countryCode.toUpperCase();
            let comparison = 0;

            if (countryA > countryB) {
                comparison = 1;
            } else if (countryA < countryB) {
                comparison = -1;
            }

            return comparison;
        };

        const goingUp = (a, b) => {
            const countryA = a.rate;
            const countryB = b.rate;
            let comparison = 0;

            if (countryA > countryB) {
                comparison = 1;
            } else if (countryA < countryB) {
                comparison = -1;
            }

            return comparison;
        };

        const goingDown = (a, b) => {
            const countryA = a.rate;
            const countryB = b.rate;
            let comparison = 0;

            if (countryA > countryB) {
                comparison = -1;
            } else if (countryA < countryB) {
                comparison = 1;
            }

            return comparison;
        };

        if (defaultState) {
            finalOutput = staticResorts.sort(alphabetical);
        } else {
            if (sortState === 'ALPHABETICAL') {
                finalOutput = activeResortsArray.sort(alphabetical);
            } else if (sortState === 'LOWTOHIGH') {
                finalOutput = activeResortsArray.sort(goingUp);
            } else {
                finalOutput = activeResortsArray.sort(goingDown);
            }
        }

        this.setState(
            {
                filteredResorts: finalOutput,
            },
            () => this.stickyCheck()
        );

        setTimeout(() => {
            this.setState({ loading: false });
        }, 1000);
    };

    textResults = () => {
        const { resetState, activeResorts, filters } = this.state;
        const { sliderStyle } = this.props;
        const activeText = () => {
            let multiple = false;
            const filterNames = Object.keys(filters);
            const counter = filterNames.reduce((acc, filter) => {
                if (filters[filter].length > 0) {
                    acc++;
                }

                return acc;
            }, 0);

            if (counter > 1) {
                multiple = true;
            }

            filterNames.map(filter => {
                if (filters[filter].length > 1) {
                    multiple = true;

                    return false;
                }
            });

            if (multiple) {
                return 'Selections';
            } else {
                return 'Selection';
            }
        };

        if (sliderStyle) {
            if (resetState === false) {
                return 'Filter resorts by...';
            } else {
                return `${activeResorts.length} ${
                    activeResorts.length > 1 ? 'Resorts' : 'Resort'
                } Matching Your ${activeText()}`;
            }
        } else {
            if (resetState === false) {
                return 'Showing All Sandals Resorts';
            } else {
                return `${activeResorts.length} ${
                    activeResorts.length > 1 ? 'Resorts' : 'Resort'
                } Matching Your ${activeText()}`;
            }
        }
    };

    showFilter = () => {
        const { filterShow } = this.state;
        const { sliderStyle } = this.props;

        if (!sliderStyle || window.innerWidth < 768) {
            if (filterShow) {
                this.setState({ filterShow: false });
                document
                    .querySelector('body')
                    .classList.remove('prevent-scroll');
            } else {
                this.setState({ filterShow: true });
                document.querySelector('body').classList.add('prevent-scroll');
            }
        } else {
            if (filterShow) {
                this.setState({ filterShow: false });
            } else {
                this.setState({ filterShow: true });
            }
        }
    };

    sliderNeeded = () => {
        const { activeResorts, defaultState } = this.state;
        let needed;

        if (defaultState) {
            needed = true;
        } else {
            if (window.innerWidth > 992) {
                activeResorts.length > 3 ? (needed = true) : (needed = false);
            } else if (window.innerWidth < 992 && window.innerWidth > 767) {
                activeResorts.length > 2 ? (needed = true) : (needed = false);
            } else {
                activeResorts.length > 1 ? (needed = true) : (needed = false);
            }
        }

        return needed;
    };

    sliderTextResults = () => {
        const { resetState, activeResorts, filters } = this.state;
        const activeText = () => {
            let multiple = false;
            const filterNames = Object.keys(filters);
            const counter = filterNames.reduce((acc, filter) => {
                if (filters[filter].length > 0) {
                    acc++;
                }

                return acc;
            }, 0);

            if (counter > 1) {
                multiple = true;
            }

            filterNames.map(filter => {
                if (filters[filter].length > 1) {
                    multiple = true;

                    return false;
                }
            });

            if (multiple) {
                return 'Selections';
            } else {
                return 'Selection';
            }
        };

        if (resetState === true) {
            return `${activeResorts.length} ${
                activeResorts.length > 1 ? 'Resorts' : 'Resort'
            } Matching Your ${activeText()}`;
        }
    };

    getFeatures = () => {
        const {questionsAnswersWithResorts} = this.props;
        const featuresByResort = {};

        questionsAnswersWithResorts.map(feature => {
            const rstCode = feature.rstCode;

            if(!(rstCode in featuresByResort)) {
                featuresByResort[rstCode] = [];
            }
            featuresByResort[rstCode].push(feature.questionText);
        });

        return featuresByResort;
    }

    getMoods = () => {
        const activityNames = Object.keys(this.props.staticActivities);
        const moodsByResort = {};

        activityNames.forEach(activity => {
            const moods = ['lively', 'innovative', 'laidback', 'casual', 'intimate', 'elegant'];
            const rstCodes = this.props.staticActivities[activity];

            if(!moods.includes(activity)) {
                return;
            }
            rstCodes.forEach(rstCode => {
                if(!(rstCode in moodsByResort)) {
                    moodsByResort[rstCode] = [];
                }
                moodsByResort[rstCode].push(activity);
            });
        });

        return moodsByResort;
    }

    render() {
        const { sliderOptions } = internals;

        const {
            activeResorts,
            resetState,
            filterItem,
            disabledFeatures,
            disabledCountries,
            disabledActivities,
            filterShow,
            showButton,
            filters,
            filteredResorts,
            loading,
            featuresByResort,
            moodsByResort,
            mainFeatures
        } = this.state;
        const {
            staticResorts,
            rates,
            staticActivities,
            features,
            slideImages,
            filterData,
            countryCodes,
            activityNamesUsing,
            sliderStyle,
        } = this.props;

        return (
            <div className="row">
                <div
                    className={`navSection col-xs-12 col-md-4 ${
                        filterShow ? 'show' : 'hide'
                    }`}
                    ref={this.setWrapperRef}
                >
                    <NavResorts
                        resorts={staticResorts}
                        activeResorts={activeResorts}
                        resetButton={resetState}
                        resetClick={this.reset.bind(this)}
                        countryChange={this.selectFilter.bind(this)}
                        activityChange={this.selectFilter.bind(this)}
                        staticActivities={staticActivities}
                        features={features}
                        featureChange={this.selectFilter.bind(this)}
                        disabledFeatures={disabledFeatures}
                        disabledCountries={disabledCountries}
                        disabledActivities={disabledActivities}
                        viewResorts={this.showFilter.bind(this)}
                        showButton={showButton}
                        countryCodes={countryCodes}
                        activityNamesUsing={activityNamesUsing}
                        filters={filters}
                        sliderStyle={sliderStyle}
                    />
                </div>
                <div
                    className={`view-resort-module col-xs-12 ${
                        sliderStyle ? '' : 'col-md-8'
                    } ${
                        filteredResorts.length <= 6 ? 'canSticky' : 'noSticky'
                    } ${filterShow ? 'filter-showing' : ''}`}
                >
                    <div className="view-resort-module-inner">
                        {loading && !sliderStyle ? (
                            <div className="loader" />
                        ) : (
                            ''
                        )}
                        <div className="top-row">
                            <i
                                className="ic ic-refine desktop-hide"
                                onClick={() => this.showFilter()}
                                ref={this.filterOpenRef}
                            />
                            {sliderStyle || window.innerWidth < 992 ? (
                                <p
                                    id="filterResults"
                                    onClick={() => this.showFilter()}
                                    ref={this.filterResults}
                                >
                                    {window.innerWidth > 767
                                        ? 'Filter resorts by...'
                                        : this.textResults()}
                                </p>
                            ) : (
                                <p id="filterResults">{this.textResults()}</p>
                            )}
                            <SortFilter
                                class="sortFilter"
                                data={filterData}
                                checked={filterItem}
                                change={this.createSortObject.bind(this)}
                            />
                            {sliderStyle && resetState && !filterShow ? (
                                <div className="results-copy">
                                    {this.sliderTextResults()}{' '}
                                    <ResetButton
                                        clickHandler={this.reset.bind(this)}
                                    />
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        <div
                            className={`resort-list row ${
                                this.sliderNeeded() ? 'sliding' : 'no-sliding'
                            }`}
                        >
                            {sliderStyle && this.sliderNeeded() ? (
                                <Slider {...sliderOptions}>
                                    {filteredResorts.map((resort, index) => {
                                        return (
                                            <ResortCard
                                                sliderStyle={sliderStyle}
                                                rates={rates}
                                                resort={resort}
                                                staticResortInfo={
                                                    resorts.resort
                                                }
                                                sliderMode
                                                index={index}
                                                key={`card-${resort.rstCode}`}
                                                slideImages={
                                                    slideImages[
                                                        resort.rstCode.toLowerCase()
                                                    ].slides
                                                }
                                             
                                                mainFeatures={mainFeatures}
                                            />
                                            
                                        );
                                       
                                       
                                    })}
                                    
                                </Slider>
                            ) : (
                                filteredResorts.map((resort, index) => {
                                    // console.log(resort);
                                    return (
                                        <ResortCard
                                            sliderStyle={sliderStyle}
                                            rates={rates}
                                            resort={resort}
                                            staticResortInfo={resorts.resort}
                                            features={featuresByResort[resort.rstCode]}
                                            moods={moodsByResort[resort.rstCode]}
                                            index={index}
                                            key={`card-${resort.rstCode}`}
                                            slideImages={
                                                slideImages[
                                                    resort.rstCode.toLowerCase()
                                                ].slides
                                            }
                                            mainFeatures={mainFeatures}
                                            
                                        />
                                    );
                                   
                                })
                                
                            )}
                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

AllResorts.defaultProps = {
    staticResorts: sandals_app.page.resorts,
    stickyCheck: false,
    sliderStyle: false,
};

export default AllResorts;